export default __webpack_public_path__ + "static/media/ban-image.cf69b1e8.png";